<template>
  <div>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'App',

  props: {
    settings: {
      type: [Array, Object],
      default: () => {
        return {}
      },
    },
    readonly: {
      type: [Array, Object],
      default: () => {
        return {}
      },
    },
    texts: {
      type: [Array, Object],
      default: () => {
        return {}
      },
    },
    link: {
      type: String,
      default: '',
    },
  },

  created: function () {
    Vue.prototype.$readOnly = this.readonly
    Vue.prototype.$settings = this.settings
    Vue.prototype.$texts = this.texts
    Vue.prototype.$link = this.link

    // Cashback Client
    this.$cashback.token = this.settings.userToken
    this.$cashback.publisherClientId = this.settings.publisherClientId
    this.$cashback.withSentry(this.settings.sentryDSN)

    if (this.settings.baseUrl && this.settings.baseUrl !== '') {
      this.$cashback.baseUrl = this.settings.baseUrl
    }
  },
}
</script>
